import { orderActionTypes } from "../../actionTypes/orders/order.actionTypes";

const initialState = {
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  createdOrderId: null,
  orders: [],
  totalCount: 0,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case orderActionTypes.START_ADD_ORDER:
    case orderActionTypes.START_FETCH_ORDERS:
      return setStateLoading(state);

    case orderActionTypes.ADD_ORDER_SUCCESS:
      return setOrderSuccess(state, action);

    case orderActionTypes.FETCH_ORDERS_SUCCESS:
      return setOrdersSuccess(state, action);

    case orderActionTypes.ADD_ORDER_FAILURE:
    case orderActionTypes.FETCH_ORDERS_FAILURE:
      return setStateFailure(state, action);

    case orderActionTypes.CLEAR_ORDERS: // Reset orders on logout
      return initialState;

    default:
      return state;
  }
};

const setStateLoading = (state) => ({
  ...state,
  stateInfo: {
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  },
});

const setOrderSuccess = (state, action) => ({
  ...state,
  createdOrderId: action.data,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setOrdersSuccess = (state, action) => ({
  ...state,
  orders: action.data.items,
  totalCount: action.data.totalCount,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setStateFailure = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: true,
    error: action.error,
  },
});

export default orderReducer;
